/**
 *
 * ColorPickerList
 *
 */
import React, { useEffect } from 'react';
import { Color } from 'lib/modelBuilder/entities/Color';

import styled from 'styled-components/macro';
import ReactTooltip from 'react-tooltip';
// eslint-disable-next-line no-restricted-imports
import { css } from 'styled-components';
import {
  ALUMINIUM_COLOR,
  BLACK_OPAQUE_COLOR,
  GLASS_COLOR,
  MIRROR_COLOR,
  WHITE_OPAQUE_COLOR,
} from '../../lib/modelBuilder/constants';
import { useTranslation } from 'react-i18next';

interface Props {
  colors: Color[];
  onClick: any;
  onMouseOver?: any;
  onDoubleClick?: any;
  selectedColor?: Color | undefined;
  bigColors?: string[];
  glass?: boolean;
  dimension?: string;
}

function ColorPickerList({
  colors,
  onClick,
  onMouseOver,
  onDoubleClick,
  selectedColor,
  bigColors = [
    WHITE_OPAQUE_COLOR,
    BLACK_OPAQUE_COLOR,
    GLASS_COLOR,
    MIRROR_COLOR,
    ALUMINIUM_COLOR,
  ],
  glass,
  dimension,
}: Props) {
  // Rebuilt tooltip if colors change
  useEffect(() => ReactTooltip.rebuild(), [colors]);

  const { t } = useTranslation();

  const isBigImg = (reference: string) => bigColors.includes(reference);

  return (
    <>
      <StyledColorsContainer>
        {colors &&
          colors.map(color => (
            <StyledColorIconContainer
              key={color.reference}
              selected={color.id === selectedColor?.id}
              big={isBigImg(color.reference)}
            >
              <StyledColorIcon
                color={color.hexaHtml}
                onClick={() => {
                  onClick(color);
                }}
                onMouseOver={() => {
                  if (onMouseOver) {
                    onMouseOver(color);
                  }
                }}
                onDoubleClick={onDoubleClick}
                // onMouseLeave={onLeave}
                data-tip={`${color.name}${glass ? ` + ${t('Glass')}` : ''} ${
                  dimension ? `${dimension}` : ''
                }`}
                data-for="nameInfo"
                big={isBigImg(color.reference)}
              >
                {color.texture && <img src={color.texture} alt={color.name} />}
              </StyledColorIcon>
            </StyledColorIconContainer>
          ))}
      </StyledColorsContainer>
      <ReactTooltip id="nameInfo" place="bottom" type="dark" />
    </>
  );
}

export default ColorPickerList;

const StyledColorsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  //margin-top: 1rem;
  overflow: auto;
  background-color: white;
  //height: 10rem;
  @media (max-width: 1023px) {
    max-height: 10rem;
  }
  @media (min-width: 1024px) {
    height: 7rem;
  }
`;

const StyledColorIconContainer = styled.div<{
  selected?: boolean;
  big?: boolean;
}>`
  padding: 0.5rem;
  background-color: white;
  height: 3.5rem;

  ${p =>
    p.big &&
    css`
      height: 5rem;
    `}

  ${p =>
    p.selected &&
    css`
      background-color: ${p => p.theme.main} !important;
    `}

  &:hover {
    background-color: ${p => p.theme.hover};
  }
`;

const StyledColorIcon = styled.button<{ color: string; big?: boolean }>`
  //h-8 w-8 bg-green mx-2 my-2
  height: 2.5rem;
  width: 2.5rem;
  
  ${p =>
    p.big &&
    css`
      height: 4rem;
      width: 4rem;
    `}

  background-color: ${p => p.color};
  border: solid 1px #e2e8f0;
  //box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
`;
